import { Dispatch, SetStateAction, useState } from "react";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import { Modal, Button, MenuItem } from "@mui/material";

interface ModalProps {
    open: boolean;
    onClose: () => void;
    setOpen: Dispatch<SetStateAction<boolean>>;
}

export default function CreateNewHomeLayout({
    open,
    onClose,
    setOpen,
}: ModalProps) {
    const [tierColor, setTierColor] = useState("#f59e0b");

    const colors = [
        "#c2410c",
        "#a3a3a3",
        "#facc15",
        "#e5e7eb",
        "#93c5fd",
        "#2563eb",
        "#10b981",
        "#ef4444",
    ];

    return (
        <Modal
            className="modal rejectReason_modal"
            open={open}
            onClose={onClose}
        >
            <div className="modal-dialog">
                <div className="modal-body">

                    {/* Header */}
                    <div className="modal_title">
                        <h2>Add Home Layout</h2>
                        <button
                            type="button"
                            className="btn-close"
                            onClick={() => setOpen(false)}
                            aria-label="Close"
                        >
                            <CloseIcon />
                        </button>
                    </div>

                    {/* Form */}
                    <form className="form">
                        <div className="gap_p">

                            {/* Home Label */}
                            <div className="control_group">
                                <label htmlFor="home-label">
                                    Home Label <span className="required">*</span>
                                </label>

                                <TextField
                                    select
                                    fullWidth
                                    hiddenLabel
                                    defaultValue=""
                                    SelectProps={{ displayEmpty: true }}
                                    inputProps={{ id: "home-label" }}
                                >
                                    <MenuItem value="" disabled>
                                        Select Layout Type
                                    </MenuItem>
                                    <MenuItem value="banner">Trending Now</MenuItem>
                                    <MenuItem value="featured">Shop by Category</MenuItem>
                                    <MenuItem value="deals">Featured Products</MenuItem>
                                    <MenuItem value="online">Shop the Reel</MenuItem>
                                    <MenuItem value="offline">Most Popular in UAE</MenuItem>
                                    <MenuItem value="affiliate">New Arrivals</MenuItem>
                                </TextField>
                            </div>

                            {/* Display Name */}
                            <div className="control_group">
                                <label htmlFor="display-name">
                                    Display Name <span className="required">*</span>
                                </label>

                                <TextField
                                    placeholder="Enter Display Name"
                                    fullWidth
                                    hiddenLabel
                                    inputProps={{ id: "display-name" }}
                                />
                            </div>

                        </div>

                        {/* Footer */}
                        <div className="footer_btn_flex">
                            <Button
                                className="btn"
                                onClick={() => setOpen(false)}
                            >
                                Cancel
                            </Button>

                            <Button
                                className="btn btn_primary"
                                onClick={() => setOpen(false)}
                            >
                                Add Tier
                            </Button>
                        </div>
                    </form>


                </div>
            </div>
        </Modal>
    );
}
